<div class="tableContainer">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table
              border="0"
              cellpadding="0"
              role="presentation"
              style="vertical-align: top"
              width="100%"
            >
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <div class="title">
                      <h1>{{ tenantDetails.tenantName }}</h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td align="center" class="word-break">
                    <div id="printSummaryTitle" class="title">
                      {{ 'ARC_PAYMENT_PRINT_SCREEN_HEADER' | translate }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="tableContainer">
  <table class="print">
    <tr style="vertical-align: top">
      <td
        style="
          background: #ffffff;
          background-position: center center;
          background-repeat: no-repeat;
          padding: 0px;
          vertical-align: top;
        "
        height="0"
      >
        <div class="mj-hero-content" style="margin: 0px auto">
          <table class="print">
            <tr>
              <td style>
                <table class="print">
                  <tr>
                    <td align="left" class="word-break">
                      <div class="innerTable">
                        <hr color="#CECBCB" />
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
  </table>
</div>

<div class="tableContainer">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table class="print">
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <table
                      cellpadding="0"
                      width="58%"
                      border="0"
                      class="summaryHeader"
                    >
                      <tr
                        id="confirmationNumberRowId"
                        *ngIf="!hasMultipleTransactions"
                      >
                        <td class="row">
                          {{
                            'ARC_PAYMENT_CONFIRMATION_NUMBER'
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ customerPayment.masterConfirmationNumber }}
                        </td>
                      </tr>
                      <tr
                        id="accountNumberRowId"
                        *ngIf="!hasMultipleTransactions"
                      >
                        <td class="row">
                          {{
                            accountNumberLabel ?? 'ARC_PAYMENT_PRINT_ACCOUNT'
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ transactionBuyerAccounts[0] }}
                        </td>
                      </tr>
                      <tr>
                        <td class="row">
                          {{ 'ARC_PAYMENT_METHOD' | translate | uppercase }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ customerPayment.paymentMethodDisplayName }}
                        </td>
                      </tr>
                      <tr>
                        <td id="paymentDateKeyId" class="row">
                          {{
                            (customerPayment.isScheduledPayment
                              ? 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_DATE'
                              : 'ARC_PAYMENT_SUMMARY_HEADER_PAYMENT_DATE_TIME'
                            )
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          <!-- The agnostic flag on this component determines whether the date is converted to the user's local
                               time. In this case, scheduled payments should only display the date portion so there is no need to
                               convert to the user's local time zone. -->
                          <div id="paymentDateValueId">
                            {{
                              customerPayment.paymentDate
                                | paymentsEngineDatePipe
                                  : !customerPayment.isScheduledPayment
                                  : !customerPayment.isScheduledPayment
                                | async
                            }}
                          </div>

                          <!-- This component uses momentJs under the hood -->
                        </td>
                      </tr>
                      <tr id="subTotalRowId">
                        <td class="row">
                          <span style="display: block">
                            {{ 'ARC_PAYMENT_SUBTOTAL' | translate | uppercase }}
                          </span>
                          <span
                            id="appliedDiscountTotal"
                            *ngIf="isDiscountAmountVisible"
                            style="display: block"
                          >
                            ({{ transactionsAppliedDiscountTotal | currency }}
                            {{ customerPayment.currency }}
                            {{ 'ARC_PAYMENT_DISCOUNT_APPLIED' | translate }})
                          </span>
                        </td>
                        <td
                          style="
                            padding: 5px 0 5px 30px;
                            text-align: right;
                            vertical-align: text-top;
                          "
                        >
                          {{ transactionsSubTotal | currency }}
                          {{ customerPayment.currency }}
                        </td>
                      </tr>

                      <tr id="creditMemoId" *ngIf="transactionsCreditTotal">
                        <td class="row">
                          {{
                            'ARC_PAYMENT_CREDIT_MEMO_AMOUNT'
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ transactionsCreditTotal | currency }}
                          {{ customerPayment.currency }}
                        </td>
                      </tr>

                      <tr id="processingFeeId" *ngIf="isSurchargeFeeVisible">
                        <td class="row">
                          {{
                            'ARC_PAYMENT_CC_PROCESSING_FEE'
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ transactionsSurchargeTotal | currency }}
                          {{ customerPayment.currency }}
                        </td>
                      </tr>
                      <td class="row">
                        {{
                          'ARC_PAYMENT_SUMMARY_HEADER_TOTAL_AMOUNT_PAID'
                            | translate
                            | uppercase
                        }}
                      </td>
                      <td style="padding: 5px 0 5px 30px; text-align: right">
                        {{ transactionsTotal | currency }}
                        {{ customerPayment.currency }}
                      </td>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div id="transactionsTable" *ngIf="hasMultipleTransactions">
  <div
    id="transactionsTableHeader"
    class="tableContainer"
    style="display: flex; justify-content: center"
  >
    {{ 'ARC_PAYMENT_TRANSACTIONS' | translate }}
  </div>

  <div id="transactionsTableHr" class="tableContainer">
    <table class="print">
      <tr style="vertical-align: top">
        <td height="0" class="divideRow">
          <div class="mj-hero-content" style="margin: 0px auto">
            <table class="print">
              <tr>
                <td style>
                  <table class="print">
                    <tr>
                      <td align="left" class="word-break">
                        <div class="innerTable">
                          <hr color="#CECBCB" />
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div class="tableContainer">
    <table class="print">
      <tbody>
        <tr>
          <td>
            <div
              class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
            >
              <table class="print">
                <tbody>
                  <tr>
                    <td align="center" class="word-break">
                      <table
                        cellpadding="0"
                        width="100%"
                        border="0"
                        [ngClass]="
                          isSurchargeFeeVisible
                            ? 'divider dataTable sixColumns'
                            : 'divider dataTable fiveColumns'
                        "
                      >
                        <thead
                          style="
                            margin: 20px auto 1px auto;
                            display: table-row-group;
                            position: relative;
                          "
                        >
                          <tr style="color: rgba(0, 0, 0, 0.54)">
                            <th>
                              {{
                                'ARC_PAYMENT_CONFIRMATION_NUMBER'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ARC_PAYMENT_ACCOUNT' | translate | uppercase
                              }}
                            </th>
                            <th *ngIf="showDiscountAppliedColumn()">
                              {{
                                'ARC_PAYMENT_DISCOUNT_APPLIED'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ARC_PAYMENT_SUBTOTAL' | translate | uppercase
                              }}
                            </th>
                            <th *ngIf="showCreditMemoColumn()">
                              {{
                                'ARC_PAYMENT_CREDIT_MEMO_AMOUNT'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th
                              id="transactionTableCCFeeHeader"
                              *ngIf="isSurchargeFeeVisible"
                            >
                              {{
                                'ARC_PAYMENT_CC_PROCESSING_FEE'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ARC_PAYMENT_PAYABLE_AMOUNT'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{ 'ARC_PAYMENT_STATUS' | translate | uppercase }}
                            </th>
                          </tr>
                        </thead>
                        <tbody class="pum" style="margin: 30px auto 1px auto">
                          <tr *ngFor="let transaction of transactions">
                            <td>
                              {{ transaction.transactionReference }}
                            </td>
                            <td>
                              {{
                                transaction.buyerAccountIdentifier.replace(
                                  'accountNumber:',
                                  ''
                                )
                              }}
                            </td>
                            <td *ngIf="showDiscountAppliedColumn()">
                              {{ transaction.totalDiscount | currency }}
                              <span id="currency" class="text-grey">
                                {{ customerPayment.currency ?? 0 }}</span
                              >
                            </td>
                            <td>
                              {{ transaction.subtotal ?? 0 | currency }}
                              <span id="currency" class="text-grey">
                                {{ customerPayment.currency }}</span
                              >
                            </td>
                            <td *ngIf="showCreditMemoColumn()">
                              {{ transaction.totalCredit ?? 0 | currency }}
                              <span id="currency" class="text-grey">
                                {{ customerPayment.currency }}</span
                              >
                            </td>
                            <td
                              id="transactionTableCCFeeValue"
                              *ngIf="isSurchargeFeeVisible"
                            >
                              {{ transaction.totalSurcharge ?? 0 | currency }}
                              <span id="currency" class="text-grey">
                                {{ customerPayment.currency }}</span
                              >
                            </td>
                            <td>
                              {{ transaction.totalAmount ?? 0 | currency }}
                              <span id="currency" class="text-grey">
                                {{ customerPayment.currency }}</span
                              >
                            </td>
                            <td>{{ transaction.status | titlecase }}</td>
                          </tr>
                        </tbody>
                        <tbody></tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    id="documentsTableHeader"
    class="tableContainer"
    style="display: flex; justify-content: center"
  >
    {{ 'ARC_PAYMENT_DOCUMENTS' | translate }}
  </div>
</div>

<div class="tableContainer">
  <table class="print">
    <tr style="vertical-align: top">
      <td height="0" class="divideRow">
        <div class="mj-hero-content" style="margin: 0px auto">
          <table class="print">
            <tr>
              <td style>
                <table class="print">
                  <tr>
                    <td align="left" class="word-break">
                      <div class="innerTable">
                        <hr color="#CECBCB" />
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
  </table>
</div>

<div class="tableContainer" *ngIf="displayReference">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table class="print">
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <table
                      cellpadding="0"
                      width="58%"
                      border="0"
                      class="summaryHeader"
                    >
                      <tr id="referenceNumberRowId">
                        <td class="row">
                          {{
                            'ARC_PAYMENT_REFERENCE_NUMBER'
                              | translate
                              | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{
                            !referenceNumber || referenceNumber.trim() === ''
                              ? '&mdash;'
                              : referenceNumber
                          }}
                        </td>
                      </tr>
                      <tr id="referenceDateRowId">
                        <td class="row">
                          {{
                            'ARC_PAYMENT_REFERENCE_DATE' | translate | uppercase
                          }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{
                            referenceDate == null
                              ? '&mdash;'
                              : (referenceDate | date: 'mediumDate')
                          }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="tableContainer" *ngIf="displayCustomFields">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table class="print">
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <table
                      cellpadding="0"
                      width="58%"
                      border="0"
                      class="summaryHeader"
                    >
                      <tr id="dropdownRowId" *ngIf="dropdownSettings.enabled">
                        <td class="row">
                          {{ dropdownSettings.label | translate | uppercase }}
                        </td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{ dropdownSelection }}
                        </td>
                      </tr>
                      <tr
                        id="paymentNoteRowId"
                        *ngIf="paymentNoteSettings.enabled"
                      >
                        <td class="payment-note-label row">
                          {{
                            paymentNoteSettings.label | translate | uppercase
                          }}
                        </td>
                        <td
                          style="
                            padding: 5px 0 5px 30px;
                            text-align: right;
                            max-width: 80px;
                          "
                        >
                          {{ paymentNotes }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="tableContainer" *ngIf="customTemplateFields?.length > 0">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table class="print">
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <table
                      cellpadding="0"
                      width="58%"
                      border="0"
                      class="summaryHeader"
                    >
                      <!-- Standard fields (isCustom=false, type != FreeTextNote: FixedNote, Date, etc.) -->
                      <tr *ngFor="let field of standardTemplateFields">
                        <td class="row">{{ field.label | uppercase }}</td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{
                            field.type === 'Date'
                              ? (field.value | date: 'mediumDate') || '—'
                              : field.value || '—'
                          }}
                        </td>
                      </tr>
                      <!-- Custom fields (isCustom=true: FreeTextNote, FixedNote, Date) -->
                      <tr *ngFor="let field of orderedCustomFields">
                        <td class="row">{{ field.label | uppercase }}</td>
                        <td style="padding: 5px 0 5px 30px; text-align: right">
                          {{
                            field.type === 'Date'
                              ? (field.value | date: 'mediumDate') || '—'
                              : field.value || '—'
                          }}
                        </td>
                      </tr>
                      <!-- Payment note (FreeTextNote isCustom=false) — always last -->
                      <tr *ngIf="printPaymentNoteField">
                        <td class="payment-note-label row">
                          {{ printPaymentNoteField.label | uppercase }}
                        </td>
                        <td
                          style="
                            padding: 5px 0 5px 30px;
                            text-align: right;
                            max-width: 80px;
                          "
                        >
                          {{ printPaymentNoteField.value || '—' }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="tableContainer" *ngIf="hasDocuments">
  <table class="print">
    <tbody>
      <tr>
        <td>
          <div
            class="mj-column-per-100 mj-outlook-group-fix innerTableContainer"
          >
            <table class="print">
              <tbody>
                <tr>
                  <td align="center" class="word-break">
                    <table
                      cellpadding="0"
                      width="100%"
                      border="0"
                      [ngClass]="
                        showPoColumn()
                          ? 'divider dataTable sixColumns'
                          : 'divider dataTable fiveColumns'
                      "
                    >
                      <thead
                        style="
                          margin: 20px auto 1px auto;
                          display: table-row-group;
                          position: relative;
                        "
                      >
                        <tr style="color: rgba(0, 0, 0, 0.54)">
                          <th>
                            {{ 'ARC_PAYMENT_DOCUMENT' | translate | uppercase }}
                          </th>
                          <th *ngIf="showAccountColumn()">
                            {{ 'ARC_PAYMENT_ACCOUNT' | translate | uppercase }}
                          </th>
                          <th *ngIf="showPoColumn()">
                            {{ 'ARC_PAYMENT_PRINT_PO' | translate | uppercase }}
                          </th>
                          <th>
                            {{
                              'ARC_PAYMENT_DOCUMENT_DATE'
                                | translate
                                | uppercase
                            }}
                          </th>
                          <th>
                            {{
                              'ARC_PAYMENT_PAYABLE_AMOUNT'
                                | translate
                                | uppercase
                            }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="pum" style="margin: 30px auto 1px auto">
                        <tr *ngFor="let doc of documents">
                          <td>
                            {{ doc.invoiceNumber ?? '' }}
                          </td>
                          <td *ngIf="showAccountColumn()">
                            {{ doc.buyerAccount }}
                          </td>
                          <td id="PoNumber" *ngIf="showPoColumn()">
                            {{ doc.poNumber }}
                          </td>
                          <td>
                            <!-- document dates are hardcoded to only display in UTC regardless of user timezone -->
                            {{
                              doc.documentDate
                                | paymentsEngineDatePipe: false : false
                                | async
                            }}
                          </td>
                          <td>
                            {{ doc.payableAmount | currency }}
                            <span id="currency" class="text-grey">
                              {{ customerPayment.currency }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                      <tbody></tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
